"use client";

import cn from "@utils/cn";
import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useContext } from "react";

import "@/components/TabNavigation/react-tabs.css";
import { TemplateContext } from "@/context/TemplateContext";
import { useHorizontalScroll } from "@/hooks/useHorizontalScroll";
import { TabNavigationProps } from "@/types";

export default function TabNavigation({ entry }: TabNavigationProps) {
  const locale = useLocale();

  const scrollRef = useHorizontalScroll();
  const { visibleHeader } = useContext(TemplateContext);

  const pathname = usePathname();
  const path = pathname.split("/");

  return (
    <div
      ref={scrollRef}
      className={cn(
        "flex z-20 overflow-scroll no-scrollbar md:mx-0 bg-white sticky",
        visibleHeader ? "top-xxl md:top-4xl mt-xxs" : "top-0 md:top-4xl",
      )}
    >
      <ul className="react-tabs__tab-list mx-auto mb-1">
        {entry.tabs.map((element) => (
          <li key={element.id}>
            <Link
              href={getLink(element, locale)}
              target={element.link.target || "_self"}
              className={cn(
                "react-tabs__tab whitespace-nowrap",
                element.link.linkType === "content" &&
                  path.findLast((element) => {
                    return element !== "";
                  }) === element.link.content?.slug &&
                  "react-tabs__tab--selected",
              )}
            >
              {element.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
